import 'COMMON';
import 'jquery-validation';
import 'Vendor/maskedinput/maskedinput';
import { svgSpriteLoader } from 'Lib/svg-sprite-loader/svg-sprite-loader';
import { oLike } from 'Lib/like/like';
import 'Lib/selectbox/selectbox';
// old
import 'Lib/old-personal-page/old-personal-page';
//
import 'Bem/site/books-slider/books-slider';
import 'Bem/site/spoiler/spoiler';
import 'Bem/site/book/book';
import 'Bem/journal/articles/articles';
import 'Bem/site/reviews/reviews';
import 'Bem/site/radio/radio';
import 'Bem/site/fileinput/fileinput';
import 'Bem/site/tabs/tabs';
import 'Bem/site/services-author/services-author';
import 'Bem/site/checkbox/checkbox';
import 'Bem/site/collection/collection';
import 'Bem/site/collections/collections';
import 'Bem/site/collection-user-add/collection-user-add';
import 'Bem/journal/article-share/article-share';
import 'Bem/site/filter-formats/filter-formats';
import 'Bem/site/audio-play/audio-play';
import 'Bem/site/author-sales/author-sales';
import 'Bem/site/tags/_add-item/tags_add-item';
import 'Bem/site/publications/publications';
import 'Bem/site/collection-management/collection-management';
import 'Bem/site/video-reviews/video-reviews';
import 'Bem/site/copy/copy';
import 'Bem/site/fileinput2/fileinput2';
import 'Bem/site/basket-wholesale/basket-wholesale';
import 'Bem/site/basket-wholesale-order/basket-wholesale-order';
import 'Bem/site/will-read/will-read';
import { Reactions } from 'Lib/reactions/reactions';
import { isNoEmptyString } from 'Lib/is-no-empty-string/is-no-empty-string';

let reactions = new Reactions(document.querySelectorAll('.reactions'));
const $myOrderCompleted = $('.lk-card_my-order-completed');
const $order = $myOrderCompleted.find('.lk-card-my-order-completed');
const cHidden = 'hidden';
const $body = $('body');

svgSpriteLoader('/site/personal/svg/sprite.svg?v=20180320');
oLike.init('.js-book-like, .js-article-like, .js-author-like');

$body.on('eksmoPagenavAjax', () => {
    reactions = new Reactions(document.querySelectorAll('.reactions'));
    reactions.init();
    oLike.init('.js-book-like, .js-article-like, .js-author-like');
});

reactions.init();

$('.js-m-menu-filter-catalog-last-lvl').on('eksmoSetMMenu', function () {
    const $this = $(this);
    const sCheckbox = '.js-filter-catalog-last-lvl-checkbox';
    const sRadioFormatLabels = '.js-filter-catalog-last-lvl-radio-format';
    const sRadioPriceLabels = '.js-filter-catalog-last-lvl-radio-price';
    const sRadioAgeLabels = '.js-filter-catalog-last-lvl-radio-age';
    const $submitLink = $this.find('.js-filter-catalog-last-lvl-submit').first();
    const oldHref = $submitLink.attr('href') || '';

    function setUrl() {
        const arrUrl = [];
        const arrUrlSections = [];

        $this.find(sRadioAgeLabels).each(function () {
            const $thisLabel = $(this);

            if ($thisLabel.find('input:checked').length) {
                const data = $thisLabel.attr('data-filter-catalog-last-lvl');

                if (isNoEmptyString(data)) {
                    if (data[0] === '/') {
                        arrUrlSections.push(data);
                    } else {
                        arrUrl.push(data);
                    }
                }
            }
        });

        $this.find(sCheckbox).each(function () {
            const $thisCheckbox = $(this);

            if (!$thisCheckbox.closest('.m-menu__item-result-finder-template').length) {
                const value = $thisCheckbox.find('input:checked').length ? $thisCheckbox.attr('data-filter-catalog-last-lvl-y') : $thisCheckbox.attr('data-filter-catalog-last-lvl-n');

                if (isNoEmptyString(value)) {
                    arrUrl.push(value);
                }
            }
        });

        $this.find(sRadioFormatLabels).each(function () {
            const $thisLabel = $(this);

            if ($thisLabel.find('input:checked').length) {
                const data = $thisLabel.attr('data-filter-catalog-last-lvl');

                if (isNoEmptyString(data)) {
                    arrUrl.push(data);
                }
            }
        });

        $this.find(sRadioPriceLabels).each(function () {
            const $thisLabel = $(this);

            if ($thisLabel.find('input:checked').length) {
                const data = $thisLabel.attr('data-filter-catalog-last-lvl');

                if (isNoEmptyString(data)) {
                    arrUrl.push(data);
                }
            }
        });

        const urlSections = arrUrlSections.map((item) => item.slice(1)).join('');

        $submitLink.removeClass('btn_disabled');
        $submitLink.attr('href', oldHref + ((oldHref.slice(-1) !== '/' && urlSections.length) ? '/' : '') + urlSections + ((oldHref.indexOf('?') + 1) ? '&' : '?') + arrUrl.join('&'));
    }

    if ($submitLink.length) {
        $this.on('eksmoChangeCheckbox', sCheckbox, setUrl);
        $this.on('eksmoChangeRadio', sRadioFormatLabels, setUrl);
        $this.on('eksmoChangeRadio', sRadioPriceLabels, setUrl);
        $this.on('eksmoChangeRadio', sRadioAgeLabels, setUrl);
    }
});

// Фильтр года на странице Мои заказы
if ($order.length) {
    $myOrderCompleted.find('.selectbox').on('changed.selectbox.eksmo', (e, value) => {
        $order.addClass(cHidden);
        $order.filter(`[data-year=${value}]`).removeClass(cHidden);
    });
}

// Нажатие на кнопку "Создать подборку"
$body.on('click', '.collection__personal-menu-item_create', function () {
    const $collection = $(this).closest('.collection');
    const id = $collection.attr('data-id');
    const name = $collection.find('.collection__name').text();

    if (typeof id === 'string' && typeof name === 'string') {
        $collection.trigger('eksmoCollectionEdit', [id, name, $collection.attr('data-description')]);
    }
});